import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import DelightYourCustomersImage from './CreateOneCustomerConversationImage'

const copy = {
  heading: `Create one customer conversation`,
  description: `Coordinate customer interactions across every touchpoint so your customer-facing teams always have the context to pick up where the conversation left off.`,
}

const DelightYourCustomers: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="2Col">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge" tag="p">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>

        <Section.Contents>
          <DelightYourCustomersImage />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Copy} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      max-width: 440px;
      align-self: center;
    }
  }
`

export default DelightYourCustomers
